import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CaseStudy from "./pages/CaseStudy";
import CaseStudiesIndex from "./pages/CaseStudiesIndex";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./i18n/LanguageContext";

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/case-studies" element={<CaseStudiesIndex />} />
                        <Route
                            path="/case-studies/:slug"
                            element={<CaseStudy />}
                        />
                        <Route path="/blog" element={<BlogIndex />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="bottom-right" />
            </LanguageProvider>
        </div>
    );
}

export default App;
